import React, { useState, useEffect } from 'react';
import { useNotifications } from '../../hooks/useNotifications';
import NotificationBell from './NotificationBell';
import NotificationsDrawer from './NotificationsDrawer';

const NotificationCenter = ({ shellConfig = null }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const {
    items,
    unreadCount,
    loading,
    error,
    hasMore,
    load,
    markRead,
    markAllRead,
    startPolling,
    stopPolling,
    reload
  } = useNotifications();

  // Start polling when component mounts, stop when drawer is open
  useEffect(() => {
    if (!isDrawerOpen) {
      // Start polling every 30 seconds when drawer is closed
      startPolling(30000);
    } else {
      // Stop polling when drawer is open
      stopPolling();
    }

    // Cleanup on unmount
    return () => {
      stopPolling();
    };
  }, [isDrawerOpen, startPolling, stopPolling]);

  // Handle bell click
  const handleBellClick = () => {
    if (isDrawerOpen) {
      setIsDrawerOpen(false);
    } else {
      // Reload notifications when opening drawer
      reload();
      setIsDrawerOpen(true);
    }
  };

  // Handle drawer close
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <NotificationBell
        unreadCount={unreadCount}
        onClick={handleBellClick}
      />
      
      <NotificationsDrawer
        isOpen={isDrawerOpen}
        onClose={handleDrawerClose}
        items={items}
        unreadCount={unreadCount}
        loading={loading}
        error={error}
        hasMore={hasMore}
        load={load}
        markRead={markRead}
        markAllRead={markAllRead}
        reload={reload}
        shellConfig={shellConfig}
      />
    </>
  );
};

export default NotificationCenter;
